import { render, staticRenderFns } from "./CourseScheduleEditor.vue?vue&type=template&id=36bd1929&scoped=true&"
import script from "./CourseScheduleEditor.vue?vue&type=script&lang=js&"
export * from "./CourseScheduleEditor.vue?vue&type=script&lang=js&"
import style0 from "./CourseScheduleEditor.vue?vue&type=style&index=0&id=36bd1929&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36bd1929",
  null
  
)

export default component.exports